import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  bullet: {
    display: 'inline-block',
    margin: `0 ${theme.spacing(1)}px`,
    transform: 'scale(0.8)',
  },
}));
